export default {
  computed: {
    language: function () {
      return this.paymentMethodResponse ? this.paymentMethodResponse['language'] : ''
    }
  },
  watch: {
    language: {
      immediate: true,
      handler(newValue) {
        let lang = newValue 
        if (!lang) {
          lang = 'fr'
          if (navigator.language) lang = navigator.language.split('-')[0]
          if (navigator.userLanguage) lang = navigator.userLanguage.split('-')[0]
        }
        else lang = lang.toLowerCase()
        this.$i18n.locale = lang
      }
    }
  },
  data: function () {
    return {
      paymentMethodResponse: null
    }
  }
}
